export default {
    selectRoot(resources, response) {
        let id;
        if (response.requestedUri.endsWith('/')) {
            id = response.requestedUri.substr(0, response.requestedUri.length - 1);
        }
        else {
            id = response.requestedUri + '/';
        }
        return resources[id];
    },
};
//# sourceMappingURL=TrailingSlashSelector.js.map